export default "__VITE_ASSET__Bm2Yd0_Z__"